/**
 * Show the debug button/panel in the image capture (AddImageModal / usePaperCamera).
 * Defaults to hidden. Override by setting VITE_IMAGE_CAPTURE_DEBUG=true in your .env.
 */
export const SHOW_IMAGE_CAPTURE_DEBUG =
  import.meta.env.VITE_IMAGE_CAPTURE_DEBUG === "true" ||
  import.meta.env.VITE_IMAGE_CAPTURE_DEBUG === "1";

const defaultGatewayBaseUrl =
  import.meta.env.DEV && typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}:3010`
    : "";

export const CANVAS_GATEWAY_BASE_URL = (
  import.meta.env.VITE_GATEWAY_BASE_URL || defaultGatewayBaseUrl
).replace(/\/+$/, "");

/**
 * Whether the canvas gateway infrastructure is available.
 * Without a gateway URL, WebSocket and REST calls would 404.
 * Per-user access is controlled by the backend via the canvas_access API
 * (backed by the `enableNotepadAgent` DynamoDB user config flag).
 */
export const CANVAS_GATEWAY_CONFIGURED = CANVAS_GATEWAY_BASE_URL.length > 0;

/**
 * No expectation mode in Lesson settings (P-PRD-525): one lesson at a time,
 * moved on only by finishing it, with no pace target.
 *
 * Off unless switched on, the same default-dark rule as `enablePacingMode`,
 * and mirrors the backend's `ENABLE_NO_EXPECTATION_MODE`, which refuses a
 * switch into the mode while it is off. Gates offering the choice, never a
 * stored value: a teacher already in the mode keeps seeing it, and can leave.
 */
export const ENABLE_NO_EXPECTATION_MODE =
  import.meta.env.VITE_ENABLE_NO_EXPECTATION_MODE === "true";
